import { Component, OnInit } from '@angular/core';
import { BaseChartMulti } from '../../question.service';

@Component({
  selector: 'app-stacked-horizontal-chart',
  templateUrl: './stacked-horizontal-chart.component.html',
  styleUrls: ['./stacked-horizontal-chart.component.css']
})
export class StackedHorizontalChartComponent extends BaseChartMulti implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  onSelect(data: any): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data: any): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data: any): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }
}
